import React from "react";
import axios from "axios";

import Camera from "./canvasMobile/camera/camera.component";

import SelectionContainerMobile from "./canvasMobile/selection/selectionContainerMobile.component";

import QuotationBtnMobile from "./canvasMobile/topMenu/quotationMobile.component";
import QuotationModalMobile from "./canvasMobile/quotation/quotationModal.component";

import ContactBtnMobile from "./canvasMobile/topMenu/contactMobile.component";
import ContactContainerMobile from "./canvasMobile/contact/contactContainerMobile.component";

import MapContainerMobile from "./canvasMobile/map/mapContainerMobile.component";

import AmenitesContainerMobile from "./canvasMobile/amenitites/amenitesContainerMobile.component";

import GalleryModalMobile from "./canvasMobile/gallery/galleryModalMobile.component";

import DetailedTour from "./canvasMobile/galleries/detailedTour.component";
import BrochuresComponent from "./canvasMobile/galleries/brochures.component";
import DetailedGallery from "./canvasMobile/galleries/detailedGallery.component";
import Viewer360ThreeMobile from "./canvasMobile/galleries/viewer360Mobile.component";

import AsoleacionBtnMobile from "./canvasMobile/topMenu/asoleacionMobile.component";

import AmenitiesLayouts from "./canvasMobile/layouts/amenities.component";

import PropertiesContainerMobile from "./canvasMobile/properties/propertiesContainer.component";
import PropertiesLayouts from "./canvasMobile/layouts/properties.component";

import PropertiesTooltip from "./canvasMobile/layouts/propertiesTooltip.component";

import arrow from "./../UI/general/collapse.svg";

import AsoleacionImages from "./canvasMobile/asoleacion/asoleacionImages.component";
import AsoleacionUI from "./canvasMobile/asoleacion/asoleacionUI.component";

import Hotspots from "./canvasMobile/layouts/hotspots.componet";

import DetailedLayoutsMobile from "./canvasMobile/layouts/detailed.component";

import TownplanningContainer from "./canvasMobile/townplanning/townplanningContainer.component";
import TownPlanningLayouts from "./canvasMobile/layouts/twonplanning.component";

import HotspotsBtnMobile from "./canvasMobile/layouts/hotspostsbtns.component";

import OptionsMobile from "./canvasMobile/topMenu/options.component";

import SecondaryLegalText from "./canvas/secondaryLegalText/secondaryText.component";

/*eslint-disable */

interface CanvasMobile {
  mainCameraRef: any;
  secondaryCameraRef: any;
  asoleacionUIRef: any;
  videoRef: any;
  layoutsRef: any;
  asoleacionVideoRef: any;
  optionsRef: any;
  propertiesContainerRef: any;
}

interface Props {
  isIngresoHidden: boolean;
  data: any;
}

interface State {
  initFramePOI: number;
  initFramePOIsecondary: number;
  isPreTransition: boolean;
  isSidebarHidden: boolean;

  towerTransition: boolean;
  showGeneralView: boolean;
  showBubbles: boolean;
  showMap: boolean;
  loadingCanvas: boolean;

  cameraAngle: number;
  mainCameraAngle: number;

  hasControl: boolean;

  links: any;
  is180: any;
  openSecondaryCamera: boolean;
  zoom: number;
  leftOffset: number;
  topOffset: number;

  selectionBtnName: string;

  isLocation: boolean;
  isamenities: boolean;
  isGallery: boolean;
  isProperties: boolean;

  amenitiesData: any;
  amenitiesBubblesTempData: any;
  amenitiesFilterId: string;
  showBillboards: boolean;
  showLayouts: boolean;
  propertiesGeneralJSON: any;
  detailsObject: any;

  isVirtualTourActive: boolean;
  isBrochure: boolean;
  isGalleryActive: boolean;
  isViewer360: boolean;

  isContactModalOpened: boolean;
  isQuotationModalOpened: boolean;
  isAsoleacionModalOpened: boolean;

  asoleacionCurrentVideo: any;
  currentVideoDuration: any;
  currentPlayingTime: any;

  topbarHidden: boolean;
  showCamera: boolean;

  showTooltip: boolean;
  clientX: string;
  clientY: string;
  filteredProperty: string;

  propertyFilterArray: any;
  propertyFilterActive: boolean;
  avalabilityAttributesToShow: any;

  asoleacionCurrentSetCount: number;
  asoleacionCurrentSetIndex: number;
  tempAsoleacionData: any;
  asoleacionCurrentSet: any;
  hotspotsData: any;
  showHotspots: boolean;
  currentHotspotSelected: string;

  isDetailedSpin: boolean
  currentSelectedDetailSpin: any;
  detailedSpinLinks: any;
  currentDetailedScript: any;
  showDetailedLayouts: boolean;

  isLoading: boolean;

  isTownplanning: boolean;
  townplanningJSON: any;
  townPlanningFilter: any;
  showTownplanningLayouts: boolean;

  showTowersBtn: boolean,

  generalSecondBatch: any

  quotationProperties: any;
  nameQuotation: any;
  phoneQuotation: any;
  emailQuotation: any;
  isCollapseQuotation: any;
  isSendQuotation: any;
  statusQuotation: any;
}
declare const window: any;

class CanvasMobile extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      initFramePOI: 0,
      initFramePOIsecondary: 0,
      isPreTransition: false,
      isSidebarHidden: false,

      towerTransition: false,
      showGeneralView: true,
      showBubbles: false,
      showMap: false,
      loadingCanvas: false,

      cameraAngle: 0,
      mainCameraAngle: 0,

      hasControl: false,

      links: [],
      is180: false,
      openSecondaryCamera: false,

      zoom: 1,
      leftOffset: 0,
      topOffset: 0,

      selectionBtnName: "",

      isLocation: false,
      isamenities: false,
      isGallery: false,
      isProperties: false,

      amenitiesData: {},
      amenitiesBubblesTempData: {},
      amenitiesFilterId: "",
      showBillboards: false,
      showLayouts: false,
      propertiesGeneralJSON: {},
      detailsObject: [],

      isVirtualTourActive: false,
      isBrochure: false,
      isGalleryActive: false,
      isViewer360: false,

      isContactModalOpened: false,
      isQuotationModalOpened: false,
      isAsoleacionModalOpened: false,

      asoleacionCurrentVideo: {},
      currentPlayingTime: 0,
      currentVideoDuration: 0,

      topbarHidden: false,
      showCamera: false,

      showTooltip: false,
      clientX: "",
      clientY: "",
      filteredProperty: "",

      propertyFilterArray: [],
      propertyFilterActive: false,
      avalabilityAttributesToShow: ["DISPONIBLE", "VENDIDO", "RESERVADO", "NO DISPONIBLE"],

      asoleacionCurrentSetCount: 0,
      asoleacionCurrentSetIndex: 0,
      tempAsoleacionData: {},
      asoleacionCurrentSet: {},

      hotspotsData: {},
      showHotspots: false,
      currentHotspotSelected: "",
      
      isDetailedSpin: false,
      currentSelectedDetailSpin: {},
      detailedSpinLinks: [],
      currentDetailedScript: {},
      showDetailedLayouts: false,

      isLoading: false,

      isTownplanning: false,
      townplanningJSON: {},
      townPlanningFilter: "",
      showTownplanningLayouts: false,

      showTowersBtn: true,

      generalSecondBatch: [],

      quotationProperties: [],
      nameQuotation: "",
      phoneQuotation: "",
      emailQuotation: "",
      isCollapseQuotation: false,
      isSendQuotation: false,
      statusQuotation: "",
    };

    this.mainCameraRef = React.createRef();
    this.secondaryCameraRef = React.createRef();
    this.asoleacionUIRef = React.createRef();
    this.videoRef = React.createRef();
    this.layoutsRef = React.createRef();
    this.asoleacionVideoRef = React.createRef();
    this.optionsRef = React.createRef();
    this.propertiesContainerRef = React.createRef()
  }

  componentDidMount = async () => {

    var canvas = document.getElementById("canvas-content");
    canvas?.addEventListener("touchstart", () => {
      if(this.propertiesContainerRef.current !== null){
        this.propertiesContainerRef.current.handleHideMenus()
      }
      this.optionsRef.current.setState({
        isOptionsOpened: false,
      });
    });

    var detailsObjectTemp: any = [];

    if (this.props.data && this.props.data.details) {
      this.props.data.details.forEach((detailedData: any) => {
        if (detailedData.scripts) {
          detailsObjectTemp.push({
            group: detailedData.group,
            groupId: detailedData.groupID,
            spin: detailedData.spinPortrait,
            script: detailedData.json_portrait,
          });
        }
      });
    }

    await fetch("./asoleacion.json")
      .then((response) => response.json())
      .then((data) => {
        this.setState(
          {
            tempAsoleacionData: data,
          },
          () => {
            this.setState(
              {
                asoleacionCurrentSet:
                  this.state.tempAsoleacionData.asoleacion.vistas[0],
              },
              () => {
                this.handleLoadGeneralView();
              }
            );
          }
        );
      });

    await fetch(
      (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
        `${this.props.data.hotspots.json_portrait}`
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          hotspotsData: data,
        });
      });

    this.setState({
      detailsObject: detailsObjectTemp,
    });

    /*this.setState({
        : this.props.data.amenities.script.json ? JSON.parse(this.props.data.amenities.script.json):{},
        propertiesGeneralJSON: this.props.data.properties.script.json ? JSON.parse(this.props.data.properties.script.json):{},
        hotspotsData: ? JSON.parse(this.props.data.hotspots.json):{},
       
        :  ? JSON.parse(this.props.data.townPlanning.json):{}
    }, () => {
        var color = '#ffffff'
        document.documentElement.style.setProperty('--primary-color',color)
    })*/

    
  };

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
    var canvas = document.getElementById("canvas-content");
    canvas?.addEventListener("touchstart", () => {
      if(this.propertiesContainerRef.current !== null){
        this.propertiesContainerRef.current.handleHideMenus()
      }
      this.optionsRef.current.setState({
        isOptionsOpened: false,
      });
    });
    if(prevProps.isIngresoHidden !== this.props.isIngresoHidden && this.props.isIngresoHidden === true){
      setTimeout(() => {
        this.handleLoadSecondBatch()
      }, 1000)
    }
  }

  handleLoadGeneralView = () => {
    this.setState(
      {
        links: [],
        openSecondaryCamera: false,
      },
      () => {
        var tempArraySpin: any = []
        if (this.props.data.spin) {
          this.props.data.spin.map((spin: any) => {
            if (spin.type === "General portrait") {
              var data = spin.files;

              data.map((data: any, index: number) => {
                if(index % 2 === 0){
                  this.setState(
                    (prevState) => ({
                      links: [
                        ...prevState.links,
                        (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + data,
                      ],
                      is180: false,
                    }),
                    () => {
                      this.setState({
                        showCamera: true,
                        showHotspots: true,
                      });
                    }
                  );
                }
                else{
                  tempArraySpin.push((window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + data)
                }
              });

              if(tempArraySpin.length === 50){
                this.setState({
                  generalSecondBatch: tempArraySpin
                })
              }
            }
          });
        }
      }
    );
  };

  handleLoadSecondBatch = () => {
    if(this.state.generalSecondBatch.length === 50){
      var counter = 0
      this.state.generalSecondBatch.forEach((src: any) => {
        new Promise((resolve,reject) => {
          const image = new Image();
          image.src = src
          image.onload = (e) => {
            counter++
            if(counter === 50){
              var finalArray = []
              for(let i = 0; i < Math.max(this.state.links.length, this.state.generalSecondBatch.length); i++){
                finalArray.push(this.state.links[i])
                finalArray.push(this.state.generalSecondBatch[i])
              }
              this.setState({
                links: finalArray
              })
            }
            }
          })
      })         
    }
  }

  handleStartTransicion = () => {
    this.handleEndTransicion();
  };

  handleSecondaryCameraAngleUpdate = (angle: number) => {
    this.setState({
      cameraAngle: angle,
    });
  };

  handleMainCameraAngleUpdate = (angle: number) => {
    this.setState({
      mainCameraAngle: angle,
    });
  };

  handleEndTransicion = () => {
    if (this.state.towerTransition) {
      this.setState({
        isPreTransition: false,
        showGeneralView: false,
        showBubbles: false,
        towerTransition: false,
        loadingCanvas: false,
      });
    } else {
      this.setState({
        isPreTransition: false,
      });
    }
  };

  on360Ready = () => {
    this.setState({
      loadingCanvas: false,
    });
  };

  notifyZoomAndOffsets = (zoom: number, leftOffset: any, topOffset: any) => {
    this.setState({
      zoom: zoom,
      leftOffset: leftOffset,
      topOffset: topOffset,
    });
  };

  handleOpenQuotationModal = () => {
    this.setState({
      isQuotationModalOpened: !this.state.isQuotationModalOpened,
    });
  };

  handleOpenContactModal = () => {
    this.setState({
      isContactModalOpened: !this.state.isContactModalOpened,
    },
    () => {
      if (this.state.isSendQuotation) {
        this.setState({
          nameQuotation: "",
          phoneQuotation: "",
          emailQuotation: "",
          quotationProperties: [],
          isSendQuotation: false,
          statusQuotation: "",
          isCollapseQuotation: false,
        });
      }
    });
  };

  handleMenuSelection = (slug: string) => {
    this.setState(
      {
        selectionBtnName: slug,
        isLocation: slug === "location",
        isTownplanning: slug === "urbanismo",
        isamenities: slug === "amenities",
        isGallery: slug === "galleries",
        isProperties: slug === "properties",
        showHotspots: slug === "properties" || slug === "",

        isContactModalOpened: false,
        isQuotationModalOpened: false,
        isGalleryActive: false,
        isBrochure: false,
        isVirtualTourActive: false,
        showTooltip: false,
        openSecondaryCamera: false,
        detailedSpinLinks: [],
        currentSelectedDetailSpin: {},
        currentHotspotSelected: "",
      },
      () => {
        if (this.state.isProperties) {
          this.setState(
            {
              isLoading: true,
              showBillboards: false,
              showDetailedLayouts: false,
              showTownplanningLayouts: false,
              amenitiesBubblesTempData: [],
              townplanningJSON: [],
              townPlanningFilter: "",
              currentDetailedScript: {},
            },
            async () => {
              await fetch(
                (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                  `${this.props.data.properties.script.json_portrait}`
              )
                .then((response) => response.json())
                .then((data) => {
                  this.setState(
                    {
                      propertiesGeneralJSON: data,
                    },
                    () => {
                      this.setState({
                        showLayouts: true,
                        isLoading: false,
                      });
                    }
                  );
                });
            }
          );
        }
        if (this.state.isamenities) {
          this.setState(
            {
              isLoading: true,
              showDetailedLayouts: false,
              showTownplanningLayouts: false,
              propertiesGeneralJSON: [],
              townplanningJSON: [],
              townPlanningFilter: "",
              showLayouts: false,
              currentDetailedScript: {},
            },
            async () => {
              await fetch(
                (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                  `${this.props.data.amenities.script.json_portrait}`
              )
                .then((response) => response.json())
                .then((data) =>
                  this.setState(
                    {
                      amenitiesBubblesTempData: data,
                    },
                    () => {
                      this.setState({
                        showBillboards: true,
                        isLoading: false,
                      });
                    }
                  )
                );
            }
          );
        }
        if (this.state.isTownplanning) {
          this.handleOpenTownPlanning();
          this.setState(
            {
              showBillboards: false,
              showLayouts: false,
              showDetailedLayouts: false,
              propertiesGeneralJSON: [],
              amenitiesBubblesTempData: [],
              townPlanningFilter: "",
              isLoading: true,
              currentDetailedScript: {},
            },
            async () => {
              await fetch(
                (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                  `${this.props.data.townPlanning.json_portrait}`
              )
                .then((response) => response.json())
                .then((data) =>
                  this.setState(
                    {
                      townplanningJSON: data,
                    },
                    () => {
                      this.setState({
                        showTownplanningLayouts: true,
                      });
                    }
                  )
                );
            }
          );
        }
        if (slug === "") {
          this.setState({
            propertiesGeneralJSON: [],
            amenitiesBubblesTempData: [],
            townplanningJSON: [],
            showBillboards: false,
            showLayouts: false,
            showTownplanningLayouts: false,
            showDetailedLayouts: false,
            currentDetailedScript: {},
            townPlanningFilter: "",
          });
        }
      }
    );
  };

  handleamenitiesMenySelection = (galleryType: any) => {
    this.setState({
      isVirtualTourActive:
        galleryType.name === "Recorridos" || galleryType.name === "Videos",
      isBrochure: galleryType.name === "Brochures",
      isGalleryActive:
        galleryType.name === "Planos" ||
        galleryType.name === "Renders 2D" ||
        galleryType.name === "Fotos 2D",
      isViewer360:
        galleryType.name === "Renders 360°" ||
        galleryType.name === "vistas por piso 360°" ||
        galleryType.name === "Fotos 360°",
      amenitiesData: galleryType,
    });
  };

  handleAmenitiesBillboardFilter = (id: string) => {
    this.setState({
      amenitiesFilterId: id,
    });
  };

  handleamenitiesFilter = (id: string, frame: number) => {
    this.setState({
      amenitiesFilterId: id,
      isPreTransition: true,
      initFramePOI: frame,
    });
  };

  handleGalleriesSelection = (galleryType: any) => {
    this.setState({
      isVirtualTourActive:
        galleryType.name === "Recorridos" || galleryType.name === "Videos",
      isBrochure: galleryType.name === "Brochures",
      isGalleryActive:
        galleryType.name === "Planos" ||
        galleryType.name === "Renders 2D" ||
        galleryType.name === "Fotos 2D",
      isViewer360:
        galleryType.name === "Renders 360°" ||
        galleryType.name === "vistas por piso 360" ||
        galleryType.name === "Fotos 360°",
      amenitiesData: galleryType,
    });
  };

  handleClose360 = () => {
    this.setState({
      isViewer360: false,
      isGallery: false,
      selectionBtnName: this.state.isamenities || this.state.isDetailedSpin  ?  this.state.selectionBtnName:"",
      showHotspots: this.state.isamenities  || this.state.isDetailedSpin  ?   false:true ,
    });
  };

  handleCloseVirtualTour = () => {
    this.setState({
      isVirtualTourActive: false,
      isGallery: false,
      selectionBtnName: this.state.isamenities || this.state.isDetailedSpin  ?  this.state.selectionBtnName:"",
      showHotspots: this.state.isamenities  || this.state.isDetailedSpin  ?   false:true ,
    });
  };

  handleCloseBrochure = () => {
    this.setState({
      isBrochure: false,
      isGallery: false,
      selectionBtnName: this.state.isamenities || this.state.isDetailedSpin  ?  this.state.selectionBtnName:"",
      showHotspots: this.state.isamenities  || this.state.isDetailedSpin  ?   false:true ,
    });
  };

  handleCloseGallery = () => {
    this.setState({
      isGalleryActive: false,
      isGallery: false,
      selectionBtnName: this.state.isamenities || this.state.isDetailedSpin  ?  this.state.selectionBtnName:"",
      showHotspots: this.state.isamenities  || this.state.isDetailedSpin  ?   false:true ,
    });
  };

  handleOpenAsoleacionModal = () => {
    this.setState(
      {
        isamenities: false,
        isProperties: false,
        isGallery: false,
        isLocation: false,
        isContactModalOpened: false,
        isQuotationModalOpened: false,
        isAsoleacionModalOpened: !this.state.isAsoleacionModalOpened,
      },
      () => {
        this.setState({
          asoleacionCurrentVideo: this.state.isAsoleacionModalOpened
            ? this.props.data.asoleacion.vistas[0]
            : {},
        });
      }
    );
  };

  handleChangeAsoleacionVideo = (payload: any) => {
    this.setState({
      asoleacionCurrentVideo: payload,
    });
  };

  handlePlayVideo = () => {
    var video = this.videoRef.current.currentVideo.current;
    video.currentTime = 0;
    video.play();
  };

  handleChangeVideoTime = (e: any) => {
    var video = this.videoRef.current.currentVideo.current;
    video.pause();
    video.currentTime = e.target.value;
    this.setState({
      currentPlayingTime: e.target.value,
    });
  };

  handleShowTooltip = (currentPropertyId: string, event: any) => {
    this.setState({
      clientX:
        event.type.indexOf("touch") === 0
          ? event.changedTouches[0].clientX
          : event.clientX,
      clientY:
        event.type.indexOf("touch") === 0
          ? event.changedTouches[0].clientY
          : event.clientY,
      showTooltip: true,
      filteredProperty: currentPropertyId,
    });
  };

  handleHideTooltip = () => {
    this.setState(
      {
        showTooltip: false,
      },
      () => {
        this.layoutsRef.current.clearLayoutFilter();
      }
    );
  };

  handlePropertiesFilter = (filter: any) => {
    var tempFilterArray: any = {};
    this.props.data.properties.attributes.forEach((attribute: any) => {
      if (filter[attribute.id] !== "") {
        tempFilterArray[attribute.id] = filter[attribute.id];
      }
    });

    this.setState({
      propertyFilterArray: tempFilterArray,
    });
  };

  handleFilterAvailability = (payload: string) => {
    var filter = this.state.avalabilityAttributesToShow;
    if (filter.includes(payload)) {
      filter.splice(filter.indexOf(payload), 1);
    } else {
      filter.push(payload);
    }
    this.setState({
      avalabilityAttributesToShow: filter,
    });
  };

  handleAsoleacionImagesCount = () => {
    this.setState({
      asoleacionCurrentSetCount:
        this.asoleacionVideoRef.current.state.currentAsoleacionSet.length,
    });
  };

  handleAsoleacionChangeIndex = (index: number) => {
    this.setState({
      asoleacionCurrentSetIndex: index,
    });
  };

  handleChangeAsoleacionTime = (index: number) => {
    if (this.state.asoleacionCurrentSetIndex > index) {
      const changeIndexInterval = setInterval(() => {
        if (this.state.asoleacionCurrentSetIndex > index) {
          this.setState({
            asoleacionCurrentSetIndex: this.state.asoleacionCurrentSetIndex - 1,
          });
        } else {
          clearInterval(changeIndexInterval);
        }
      }, 50);
    }
    if (this.state.asoleacionCurrentSetIndex < index) {
      const changeIndexInterval = setInterval(() => {
        if (this.state.asoleacionCurrentSetIndex < index) {
          this.setState({
            asoleacionCurrentSetIndex: this.state.asoleacionCurrentSetIndex + 1,
          });
        } else {
          clearInterval(changeIndexInterval);
        }
      }, 50);
    }
  };

  handleChangeAsoleacionSet = (set: any) => {
    this.setState({
      asoleacionCurrentSet: set,
    });
  };

  handleAutoplayAsoleacion = () => {
    this.setState(
      {
        asoleacionCurrentSetIndex: 0,
      },
      () => {
        if (
          this.state.asoleacionCurrentSetIndex <
          this.state.asoleacionCurrentSetCount - 1
        ) {
          const changeIndexInterval = setInterval(() => {
            if (
              this.state.asoleacionCurrentSetIndex <
              this.state.asoleacionCurrentSetCount - 1
            ) {
              this.setState({
                asoleacionCurrentSetIndex:
                  this.state.asoleacionCurrentSetIndex + 1,
              });
            } else {
              clearInterval(changeIndexInterval);
            }
          }, 50);
        }
      }
    );
  };

  handleSelectedHotspot = (name: string) => {
    this.setState(
      {
        currentHotspotSelected: name,
      },
      () => {
        var tempDetailsObject: any = {};
        this.state.detailsObject.forEach((detailedObject: any) => {
          if (detailedObject.group === this.state.currentHotspotSelected) {
            tempDetailsObject = detailedObject;
          }
        });
        this.props.data.spin.forEach((spin: any) => {
          if (tempDetailsObject.spin === spin.id) {
            var files: any = [];
            spin.files.forEach((file: string) => {
              files.push(
                (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + file
              );
            });
            tempDetailsObject["files"] = files;
          }
        });

        this.handleShowDetailedSpin(tempDetailsObject);
      }
    );
  };

  handleShowDetailedSpin = (payload: any) => {
    this.setState(
      {
        currentSelectedDetailSpin: payload,
        isLoading: true,
        isDetailedSpin: true
      },
      () => {
        if (this.state.currentSelectedDetailSpin.files) {
          this.state.currentSelectedDetailSpin.files.forEach(
            (file: any, index: number) => {
              this.setState(
                (prevState) => ({
                  detailedSpinLinks: [...prevState.detailedSpinLinks, file],
                  is180: this.state.currentSelectedDetailSpin.files === 25,
                }),
                async () => {
                  if (
                    index ===
                    this.state.currentSelectedDetailSpin.files.length - 1
                  ) {
                    await fetch(
                      (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") +
                        this.state.currentSelectedDetailSpin.script
                    )
                      .then((response) => response.json())
                      .then((data) => {
                        this.setState(
                          {
                            showHotspots: false,
                            showLayouts: false,
                            currentDetailedScript: data,
                          },
                          () => {
                            this.handlePreloadImages(
                              this.state.detailedSpinLinks
                            );
                          }
                        );
                      });
                  }
                }
              );
            }
          );
        }
      }
    );
  };

  handlePreloadImages = (payload: any) => {
    let counter = 0;
    this.setState(
      {
        isLoading: true,
      },
      () => {
        payload.forEach((imageSrc: any) => {
          const image = new Image();
          image.src = imageSrc;
          image.onload = () => {
            counter++;
            if (counter === payload.length) {
              this.setState({
                openSecondaryCamera: true,
                showDetailedLayouts: true,
                selectionBtnName: "properties",
                isProperties: true,
                isLoading: false,
              });
            }
          };
        });
      }
    );
  };

  handlePreloadImagesTownplanning = (payload: any) => {
    let counter = 0;
    this.setState(
      {
        isLoading: true,
      },
      () => {
        payload.forEach((imageSrc: any) => {
          const image = new Image();
          image.src = imageSrc;
          image.onload = () => {
            counter++;
            if (counter === payload.length) {
              this.setState({
                openSecondaryCamera: true,
                isLoading: false,
              });
            }
          };
          image.onloadedmetadata = () => {
            counter++;
            if (counter === payload.length) {
              this.setState({
                openSecondaryCamera: true,
                isLoading: false,
              });
            }
          };
        });
      }
    );
  };

  handleOpenTownPlanning = () => {
    this.props.data.spin.forEach((spin: any) => {
      if (spin.type === "Urbanismo portrait") {
        spin.files.forEach((file: any, index: number) => {
          this.setState(
            (prevState) => ({
              detailedSpinLinks: [
                ...prevState.detailedSpinLinks,
                (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + file,
              ],
              is180: spin.files.length === 25,
            }),
            () => {
              if (index === spin.files.length - 1) {
                this.handlePreloadImagesTownplanning(
                  this.state.detailedSpinLinks
                );
              }
            }
          );
        });
      }
    });
  };

  handleSelectTownPlanningFilter = (payload: string) => {
    this.setState({
      townPlanningFilter: payload,
      showTownplanningLayouts: true,
    });
  };

  handleCloseGalleryModal = () => {
    this.setState({
      isGallery: false,
      selectionBtnName: "",
    });
  };

  handleCloseDetailedSpin = () => {
    this.setState(
      {
        showTooltip: false,
        openSecondaryCamera: false,
        detailedSpinLinks: [],
        currentSelectedDetailSpin: {},
        currentHotspotSelected: "",
        showDetailedLayouts: false,
        currentDetailedScript: {},
        isDetailedSpin: false
      },
      () => {
        this.handleMenuSelection("properties");
      }
    );
  };

  handleOpenAmenitiesSpin = (spin: any) => {
    spin.files.forEach((file: any, index: number) => {
      this.setState(
        (prevState) => ({
          detailedSpinLinks: [
            ...prevState.detailedSpinLinks,
            (window.hybrid ? "" : "https://s3-umbra-storage-cloud-v2.s3.amazonaws.com/") + file,
          ],
          is180: spin.files.length === 25,
          showBillboards: false,
        }),
        () => {
          if (index === spin.files.length - 1) {
            this.handlePreloadImagesTownplanning(this.state.detailedSpinLinks);
          }
        }
      );
    });
  };

  handleCloseAmenitieSpin = () => {
    this.setState({
      detailedSpinLinks: [],
      is180: false,
      openSecondaryCamera: false,
      showBillboards: true,
    });
  };

  handleShowTowersBtn = () => {
    this.setState({
      showTowersBtn: !this.state.showTowersBtn
    })
  }

  handleSetPropertyInQuotation = (property: any) => {
    this.setState(
      {
        quotationProperties: [...this.state.quotationProperties, property],
      },
      () => {
        console.log(this.state.quotationProperties);
      }
    );
  };

  handleRemovePropertyInQuotation = (property: any) => {
    // Verificar si el ID del elemento a agregar ya existe en el arreglo
    const existingIndex = this.state.quotationProperties.findIndex(
      (item: any) => item.id === property.id
    );

    if (existingIndex !== -1) {
      // Si el elemento ya existe, lo eliminamos del arreglo usando filter
      const updatedProperties = this.state.quotationProperties.filter(
        (item: any) => item.id !== property.id
      );

      // Actualizamos el estado con el arreglo sin el elemento existente
      this.setState(
        {
          quotationProperties: updatedProperties,
        },
        () => {
          console.log("Estado actualizado:", this.state.quotationProperties);
        }
      );
    } /* else {
      // Si el elemento no existe, lo agregamos al arreglo
      this.setState(
        {
          quotationProperties: [...this.state.quotationProperties, property],
        },
        () => {
          console.log("Estado actualizado:", this.state.quotationProperties);
        }
      );
    } */
  };

  handleSendQuotation = async (params: any) => {
    params.properties = this.state.quotationProperties;
    params.project = window.project_id;
    let res: any = await axios.post(
      "https://vqr3hys2bh.execute-api.us-east-1.amazonaws.com/api/quotaton/send",
      params
    );

    this.setState({
      isSendQuotation: true,
      statusQuotation: res.data.statusCode,
    });
  };

  handleBackQuotation = async (params: any) => {
    this.setState({
      nameQuotation: "",
      phoneQuotation: "",
      emailQuotation: "",
      quotationProperties: [],
      isSendQuotation: false,
      statusQuotation: "",
      isCollapseQuotation: false,
    });
  };

  render(): React.ReactNode {
    return (
      <div
        className={
          this.props.isIngresoHidden
            ? "maqueta-page-mobile fade-in"
            : "maqueta-page-mobile fade-out"
        }
      >
        {this.props.isIngresoHidden && this.state.showCamera ? (
          <div className="canvas-content">
            <div className="canvas-3d" id="canvas-content">
              <Camera
                useSubdirectories={false}
                links={this.state.links}
                initFramePOI={this.state.initFramePOI}
                isPreTransition={this.state.isPreTransition}
                handleStartTransicion={this.handleStartTransicion}
                handleAngleUpdate={this.handleMainCameraAngleUpdate}
                onReady={() => {
                  this.setState({ loadingCanvas: false });
                }}
                is180={false}
                notifyZoomAndOffsets={this.notifyZoomAndOffsets}
                ref={this.mainCameraRef}
                hasControl={this.state.hasControl}
              />
              {
                <div
                  className={
                    this.state.openSecondaryCamera
                      ? "secondary-camera fade-in"
                      : "secondary-camera fade-out"
                  }
                >
                  <Camera
                    useSubdirectories={false}
                    links={this.state.detailedSpinLinks}
                    onReady={() => {
                      this.setState({ loadingCanvas: false });
                    }}
                    initFramePOI={this.state.initFramePOIsecondary}
                    isPreTransition={this.state.isPreTransition}
                    is180={this.state.is180}
                    //onForceUpdateBubbles={this.forceUpdateBubbles}
                    secondary={true}
                    handleAngleUpdate={this.handleSecondaryCameraAngleUpdate}
                    //rotateForBubble={this.state.rotateForBubble}
                    //handleRotateForBubbleEnded={this.rotateForBubbleEnded}
                    //bubbleAngle={this.state.bubbleAngle}
                    handleStartTransicion={this.handleStartTransicion}
                    notifyZoomAndOffsets={this.notifyZoomAndOffsets}
                    ref={this.secondaryCameraRef}
                    hasControl={this.state.hasControl}
                  />
                </div>
              }
            </div>
          </div>
        ) : null}
        {this.state.showTownplanningLayouts ? (
          <TownPlanningLayouts
            isTownPlanning={this.state.showTownplanningLayouts}
            scriptData={this.state.townplanningJSON}
            townPlanningFilter={this.state.townPlanningFilter}
            angle={this.state.cameraAngle}
            attributesData={this.props.data.properties.attributes}
          />
        ) : null}
        {this.state.isAsoleacionModalOpened ? (
          <AsoleacionImages
            ref={this.asoleacionVideoRef}
            handleAsoleacionImagesCount={this.handleAsoleacionImagesCount}
            asoleacionCurrentSetIndex={this.state.asoleacionCurrentSetIndex}
            isAsoleacionModalOpened={this.state.isAsoleacionModalOpened}
            asoleacionCurrentSet={this.state.asoleacionCurrentSet}
          />
        ) : null}
        {this.state.showLayouts ? (
          <PropertiesLayouts
            ref={this.layoutsRef}
            showLayouts={this.state.showLayouts}
            angle={this.state.mainCameraAngle}
            scriptData={this.state.propertiesGeneralJSON}
            handleShowTooltip={this.handleShowTooltip}
            colorsData={this.props.data.colors}
            propertiesData={this.props.data.properties}
            propertyFilterArray={this.state.propertyFilterArray}
            avalabilityAttributesToShow={this.state.avalabilityAttributesToShow}
            hasDispo={this.props.data.properties.disponibilidad}
            links={this.state.links}
          />
        ) : null}
        {this.state.showBillboards && this.state.amenitiesBubblesTempData.amenities_coord_file ? (
          <AmenitiesLayouts
            amenitiesData={this.state.amenitiesBubblesTempData}
            amenitiesImages={this.props.data.amenities}
            amenityFilter={this.state.amenitiesFilterId}
            colorsData={this.props.data.colors}
            angle={this.state.mainCameraAngle}
            show={this.state.showBillboards}
            amenitiesProps={this.props.data.amenities}
            handleAmenitiesBillboardFilter={this.handleAmenitiesBillboardFilter}
            links={this.state.links}
          />
        ) : null}
        {this.state.showDetailedLayouts ? (
          <DetailedLayoutsMobile
            ref={this.layoutsRef}
            showDetailedLayouts={this.state.showDetailedLayouts}
            angle={this.state.cameraAngle}
            scriptData={this.state.currentDetailedScript}
            handleShowTooltip={this.handleShowTooltip}
            colorsData={this.props.data.colors}
            propertiesData={this.props.data.properties}
            propertyFilterArray={this.state.propertyFilterArray}
            avalabilityAttributesToShow={this.state.avalabilityAttributesToShow}
            hasDispo={this.props.data.properties.disponibilidad}
          />
        ) : null}
        
        {this.state.showHotspots ? (
          <Hotspots
            showHotspots={this.state.showHotspots}
            hotspotsData={this.state.hotspotsData}
            angle={this.state.mainCameraAngle}
            handleSelectedHotspot={this.handleSelectedHotspot}
            colorsData={this.props.data.colors}
            showTowersBtn = {this.state.showTowersBtn}
            propertiesData={this.props.data.properties}
            links={this.state.links}
          />
        ) : null}
        <div className="topbar-container">
          <div
            className={
              !this.state.topbarHidden ? "topbar-show" : "topbar-hidden"
            }
          >
            {
              this.state.showHotspots && this.state.hotspotsData.hotspots_coord_file ?
              <HotspotsBtnMobile
                colorsData={this.props.data.colors}
                handleShowTowersBtn = {this.handleShowTowersBtn}
                showTowersBtn = {this.state.showTowersBtn}
                propertiesData={this.props.data.properties}
              />:null
            }
            <ContactBtnMobile
              colorsData={this.props.data.colors}
              handleOpenContactModal={this.handleOpenContactModal}
            />
            {this.props.data?.cotizaciion ? (
              <QuotationBtnMobile
                handleOpenQuotationModal={this.handleOpenQuotationModal}
                isAsoleacionModalOpened={this.state.isAsoleacionModalOpened}
                isQuotationModalOpened={this.state.isQuotationModalOpened}
              />
            ) : null}
            {!this.state.topbarHidden ?
              <OptionsMobile
                ref = {this.optionsRef}
                colorsData={this.props.data.colors}
              />:null
            }
          </div>
          <div
            className="topbar-arrow"
            onClick={() => {
              this.setState({ topbarHidden: !this.state.topbarHidden });
            }}
          >
            <img
              src={arrow}
              alt=""
              style={{
                transition: "all 0.2s ease-in-out",
                transform: this.state.topbarHidden
                  ? "translate(-50%,-50%) rotate(0deg)"
                  : "translate(-50%,-50%) rotate(180deg)",
              }}
            />
          </div>
        </div>
        {this.props.data.asoleacion ? (
          <AsoleacionBtnMobile
            colorsData={this.props.data.colors}
            handleOpenAsoleacionModal={this.handleOpenAsoleacionModal}
            topbarHidden={this.state.topbarHidden}
          />
        ) : null}
        {
          <MapContainerMobile
            isLocation={this.state.isLocation}
            locationData={this.props.data.location}
            colorsData={this.props.data.colors}
          />
        }

        <SelectionContainerMobile
          data={this.props.data}
          handleMenuSelection={this.handleMenuSelection}
          selectionBtnName={this.state.selectionBtnName}
        />

        {this.state.isProperties ? (
          <PropertiesContainerMobile
            ref = {this.propertiesContainerRef}
            isProperties={this.state.isProperties}
            colorsData={this.props.data.colors}
            inmueblesData={this.props.data}
            handlePropertiesFilter={this.handlePropertiesFilter}
            avalabilityAttributesToShow={this.state.avalabilityAttributesToShow}
            handleFilterAvailability={this.handleFilterAvailability}
            isDetailed={this.state.currentSelectedDetailSpin}
            handleCloseDetailedSpin={this.handleCloseDetailedSpin}
            hasDispo={this.props.data.properties.disponibilidad}
          />
        ) : null}
        {this.state.isamenities ? (
          <AmenitesContainerMobile
            isamenities={this.state.isamenities}
            amenitiesData={this.props.data.amenities}
            colorsData={this.props.data.colors}
            handleamenitiesMenySelection={this.handleamenitiesMenySelection}
            handleamenitiesFilter={this.handleamenitiesFilter}
            amenitiesFilterId={this.state.amenitiesFilterId}
            handleOpenAmenitiesSpin={this.handleOpenAmenitiesSpin}
            handleCloseAmenitieSpin={this.handleCloseAmenitieSpin}
          />
        ) : null}
        {this.state.isTownplanning ? (
          <TownplanningContainer
            isTownplannig={this.state.isTownplanning}
            colorsData={this.props.data.colors}
            attributesData={this.props.data.properties.attributes}
            handleSelectTownPlanningFilter={this.handleSelectTownPlanningFilter}
          />
        ) : null}
        {this.state.tempAsoleacionData.asoleacion &&
        this.state.tempAsoleacionData.asoleacion.times &&
        this.state.tempAsoleacionData.asoleacion.vistas ? (
          <AsoleacionUI
            handleAsoleacionImagesCount={this.handleAsoleacionImagesCount}
            asoleacionCurrentSetCount={this.state.asoleacionCurrentSetCount}
            handleAsoleacionChangeIndex={this.handleAsoleacionChangeIndex}
            isAsoleacionModalOpened={this.state.isAsoleacionModalOpened}
            handleOpenAsoleacionModel={this.handleOpenAsoleacionModal}
            //asolacionData = {this.props.data.asoleacion}
            asolacionData={this.state.tempAsoleacionData.asoleacion}
            colorsData={this.props.data.colors}
            handleChangeAsoleacionTime={this.handleChangeAsoleacionTime}
            asoleacionCurrentSetIndex={this.state.asoleacionCurrentSetIndex}
            handleChangeAsoleacionSet={this.handleChangeAsoleacionSet}
            handleAutoplayAsoleacion={this.handleAutoplayAsoleacion}
            asoleacionCurrentSet={this.state.asoleacionCurrentSet}
          />
        ) : null}
        <QuotationModalMobile
          isQuotationModalOpened={this.state.isQuotationModalOpened}
          handleOpenQuoationModal={this.handleOpenQuotationModal}
          quotationProperties={this.state.quotationProperties}
          colors={this.props.data.colors}
          handleSendQuotation={this.handleSendQuotation}
          handleRemovePropertyInQuotation={
            this.handleRemovePropertyInQuotation
          }
          isSendQuotation={this.state.isSendQuotation}
          statusQuotation={this.state.statusQuotation}
        />
        {this.state.isGallery ? (
          <GalleryModalMobile
            galleryData={this.props.data.galleries}
            colorsData={this.props.data.colors}
            isGallery={this.state.isGallery}
            handleGalleriesSelection={this.handleGalleriesSelection}
            handleCloseGalleryModal={this.handleCloseGalleryModal}
          />
        ) : null}
        {this.state.isVirtualTourActive ? (
          <DetailedTour
            isVirtualTourActive={this.state.isVirtualTourActive}
            amenityData={this.state.amenitiesData}
            handleCloseVirtualTour={this.handleCloseVirtualTour}
            colorsData={this.props.data.colors}
          />
        ) : null}
        {this.state.isBrochure ? (
          <BrochuresComponent
            isBrochureActive={this.state.isBrochure}
            amenityData={this.state.amenitiesData}
            handleCloseBrochure={this.handleCloseBrochure}
            colorsData={this.props.data.colors}
          />
        ) : null}
        {this.state.isGalleryActive ? (
          <DetailedGallery
            isGalleryActive={this.state.isGalleryActive}
            amenityData={this.state.amenitiesData}
            colorsData={this.props.data.colors}
            handleCloseGallery={this.handleCloseGallery}
          />
        ) : null}
        {this.state.isViewer360 ? (
          <Viewer360ThreeMobile
            isViewer360={this.state.isViewer360}
            amenityData={this.state.amenitiesData}
            colorsData={this.props.data.colors}
            handleCloseGallery={this.handleClose360}
          />
        ) : null}
        <ContactContainerMobile
          logoProyecto={this.props.data.logo_constructora}
          isContactModalOpened={this.state.isContactModalOpened}
          data={this.props.data.contact}
          colorsData={this.props.data.colors}
          handleOpenContactModal={this.handleOpenContactModal}
        />
        {this.state.showTooltip ? (
          <PropertiesTooltip
            clientX={this.state.clientX}
            clientY={this.state.clientY}
            showTooltip={this.state.showTooltip}
            handleHideTooltip={this.handleHideTooltip}
            filteredProperty={this.state.filteredProperty}
            propertiesData={this.props.data.properties}
            handleamenitiesMenySelection={this.handleamenitiesMenySelection}
            handleSetPropertyInQuotation={this.handleSetPropertyInQuotation}
            handleRemovePropertyInQuotation={
              this.handleRemovePropertyInQuotation
            }
            quotationProperties={this.state.quotationProperties}
            colors={this.props.data.colors}
            isQuotation={this.props.data.cotizaciion}
          />
        ) : null}

{
          <SecondaryLegalText
            data={this.props.data}
          />
        }
        {
          <div
            className={
              this.state.isLoading
                ? "canvas-loading fade-in"
                : "canvas-loading fade-out"
            }
          >
            <svg
              className="loader-circle-canvas"
              viewBox="0 0 150 150"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                className="internal-circle-canvas"
                cx="75"
                cy="75"
                r="70"
              ></circle>
            </svg>
            <svg
              className="loader-circle-over-canvas"
              viewBox="0 0 150 150"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                className="internal-circle-over-canvas"
                cx="75"
                cy="75"
                r="70"
              ></circle>
            </svg>
          </div>
        }
      </div>
    );
  }
}

export default CanvasMobile;
